<template>
    <!-- 关联订单 -->
    <div class="wid-100">
        <!--  v-show="$route.meta.showFather" -->
        <div class="" style="" >
        <div class="box-shadow pad-16">
            <el-table ref="multipleTable" :data="tableData" class="box-table" style="width: 100%">
                <el-table-column prop="name" label="" show-overflow-tooltip>
                    <template slot-scope="scope"><span>商品名称:</span>{{scope.row.name }}</template>
                </el-table-column>
                <el-table-column prop="no" label="" show-overflow-tooltip>
                    <template slot-scope="scope"><span>订单编号:</span>{{ scope.row.no }}</template>
                </el-table-column>
                <el-table-column prop="payPrice" label="" show-overflow-tooltip>
                    <template slot-scope="scope"><span>支付金额:</span>{{ scope.row.payPrice }}元</template>
                </el-table-column>
                <el-table-column prop="payTime" label="" show-overflow-tooltip>
                    <template slot-scope="scope"><span>购买时间:</span>{{ utils.getNowTime(scope.row.payTime) }}</template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"
                layout="total, sizes, prev, pager, next, jumper" :total="400">
            </el-pagination> -->
        </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getInvoiceOrder
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                tableData: [],
            }

        },
        mounted() {
          console.log(this.$route.params.id);
          this.getOrder(this.$route.params.id)
        },
        methods: {
            getOrder(id){
                getInvoiceOrder({id:id}).then(res => {
                    // console.log(res,'==')
                    this.tableData = res.data;
                    })
                    .catch(error => {
                            
                    });
            }

        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-16 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    /*    .record {
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        margin-right: 8px;
    } */

    .record-1 {
        font-size: 20px;
        color: #222222;
        padding-left: 16px;
    }

    .mb-32 {
        margin-bottom: 32px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .box-table span{
        color: #999999;font-size: 14px;font-family: font3;
        padding-right: 0.5rem;
    }
    /deep/.el-table .cell.el-tooltip{
        color: #222222;font-size: 14px;font-family: font3;
    }
    /deep/.el-table .cell{
        padding: 0;
    }
    /deep/.el-table .el-table__cell{
        padding: 1.5rem 0;
    }
 /*   /deep/.el-table__row:hover{
        background-color: #ffffff;
    } */
</style>
